import about from './images/Home/about.png';
import androidPlay from './images/Home/andriod-play.png';
import appPlayFooter from './images/Home/app-play-footer.png';
import appPlay from './images/Home/appleplay.svg';
import banner from './images/Home/banner.jpg';
import ctaRightBg from './images/Home/cta-right-bg.png';
import drone2 from './images/Home/drone-2.gif';
import drone4 from './images/Home/drone-4.png';
import drone5 from './images/Home/drone-5.png';
import drone from './images/Home/drone.png';
import faqLeftImage1 from './images/Home/faq-left-image.jpg';
import faqLeftImage2 from './images/Home/faq-left-image2.jpg';
import featureCardBg from './images/Home/feature-card-bg.svg';
import featureCenterPerson from './images/Home/feature-center-person.png';
import firstVideoBg from './images/Home/first-video-bg.jpg';
import googlePlayFooter from './images/Home/google-play-footer.png';
import googlePlay from './images/Home/googleplay.svg';
import howItWorkPerson from './images/Home/how-it-work-person.png';
import landscape from './images/Home/landscape.png';
import personFade from './images/Home/person-fade.png';
import personVideoPlaceholder from './images/Home/person-video-placeholder.png';
import playVideo from './images/Home/play-video.svg';
import secondCtaBg from './images/Home/second-cta-bg.jpg';
import step1 from './images/Home/step-1.png';
import step2 from './images/Home/step2.png';
import step3 from './images/Home/step3.png';
import testimonalFooterBg from './images/Home/testimonal-footer-bg.jpg';
import threeScreen2 from './images/Home/three-screen-2.png';
import threeScreen from './images/Home/three-screen.png';
import arrowLeft from './images/Home/arrow-left.svg';
import arrowRight from './images/Home/arrow-right.svg';
import drone6 from './images/Home/drone6.png';
import about1 from './images/Home/about1.png';
import about2 from './images/Home/about2.png';
import about3 from './images/Home/about3.png';
import howItWork1 from './images/Home/howitwork-1.jpg';
import howItWork2 from './images/Home/howitworks-2.jpg';
import howItWork3 from './images/Home/howitworks-3.jpg';
import videoSectionBg from './images/Home/video.jpg';
import playVideo1 from './images/Home/playvideo.png';
import faqbtn from './images/Home/icons/faq-button.svg';
import moneywing from './images/Home/moneywing.svg'
import facebook from './images/Home/icons/Facebook.svg';
import instagram from './images/Home/icons/Instagram.svg';
import ticktok from './images/Home/icons/Tiktok.svg';
import linkedin from './images/Home/icons/Linkedin.svg';
import youtube from './images/Home/icons/Youtube.svg';
import logo from './images/logo.png';
import email from './images/Email.png';
import arrowleft from './images/auth/arrowleft.svg';
import pause from './images/pause.png'
import pausebtn from './images/Home/pausebtn.svg'
import scrolltop from './images/Home/scrolltop.svg'
import screen1 from './images/Home/screen1.png';
import screen2 from './images/Home/screen2.png';
import screen3 from './images/Home/screen3.png';
import droneMarker from './markers/drone-marker.png'
const Images = {
  about,
  androidPlay,
  appPlayFooter,
  appPlay,
  banner,
  ctaRightBg,
  drone2,
  drone4,
  drone5,
  drone,
  featureCardBg,
  featureCenterPerson,
  firstVideoBg,
  googlePlayFooter,
  googlePlay,
  howItWorkPerson,
  landscape,
  personFade,
  personVideoPlaceholder,
  playVideo,
  secondCtaBg,
  step1,
  step2,
  step3,
  testimonalFooterBg,
  threeScreen2,
  threeScreen,
  arrowLeft,
  arrowRight,
  drone6,
  about1,
  about2,
  about3,
  about,
  howItWork1,
  howItWork2,
  howItWork3,
  videoSectionBg,
  playVideo1,
  faqbtn,
  facebook,
  instagram,
  ticktok,
  linkedin,
  youtube,
  logo,
  email,
  arrowleft,
  // virutaldemo,
  pause,
  pausebtn,
  scrolltop,
  moneywing,
  screen1,
  screen2,
  screen3,
  faqLeftImage1,
  faqLeftImage2,
  droneMarker
};

export default Images;


